import lazyBackground from './lazyBackground';

const defaultPrevArrow = `
    <div class="ui-c-slider__action" data-action="previous">
        <i class="ui-o-icon__angle--left"></i>
    </div>`;

const defaultNextArrow = `
    <div class="ui-c-slider__action" data-action="next">
        <i class="ui-o-icon__angle--right"></i>
    </div>`;

const slideItem = '.ui-c-slider__item';

/**
 * Fires after image fails to load, showing broken placeholder.
 *
 * @param {object} event       - DOM event.
 * @param {object} slick       - Slick instance.
 * @param {object} $image      - Image object.
 */
const lazyLoadError = (event, slick, $image) => {
    $image.trigger('error');
};

// Initial default slider
const $defaultSlider = $('[data-toggle="ui-slider--default"]');

lazyBackground($defaultSlider);

$defaultSlider.slick({
    slide: slideItem,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: defaultPrevArrow,
    nextArrow: defaultNextArrow,
}).on('lazyLoadError', lazyLoadError);

// Initial mega slider

/**
 * Return customized pagination.
 *
 * @param {object} slider - Slick instance.
 * @param {number} i      - Index of current slide.
 * @returns {jQuery}
 */
const customMegaPaging = (slider, i) => {
    const $template = $(`<span class="ui-c-slider__dot" data-action>
            <span class="ui-c-slider__page">${i + 1}</span>
        </span>`);

    return $template;
};

const $megaSlider = $('[data-toggle="ui-slider--mega"]');

lazyBackground($megaSlider);

$megaSlider.slick({
    autoplay: true,
    slide: slideItem,
    dots: true,
    arrows: false,
    customPaging: customMegaPaging,
}).on('lazyLoadError', lazyLoadError);

// Initial counter slider

/**
 * Fill progress indicator.
 *
 * @param {object} event        - DOM event.
 * @param {object} slick        - Slick instance.
 * @param {number} currentSlide - Index of current slide.
 * @returns {jQuery}
 */
const progressCalculator = (event, slick, currentSlide) => {
    const totalPages = Math.ceil(slick.slideCount / slick.options.slidesToScroll);
    const startingIndex = (currentSlide || 0) + 1;
    const currentPage = Math.ceil(startingIndex / slick.options.slidesToScroll);

    slick.$slider.find('.ui-c-slider__progress').text(`${currentPage}/${totalPages}`);
};

$('[data-toggle="ui-slider--counter"]').each((index, element) => {
    const $counterSlider = $(element);

    lazyBackground($counterSlider);

    $counterSlider.on('init reInit afterChange', progressCalculator);

    $counterSlider.slick({
        slide: slideItem,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        prevArrow: defaultPrevArrow,
        nextArrow: defaultNextArrow,
        appendArrows: $counterSlider.find('.ui-c-slider__actions'),
    }).on('lazyLoadError', lazyLoadError);
});

// Thumbnails
$('[data-toggle="ui-slider--thumbnail"]').each((index, element) => {
    const $thumbnailSlider = $(element);
    const $slides = $thumbnailSlider.find('.ui-c-slider__slides');
    const $thumbnails = $thumbnailSlider.find('.ui-c-slider__thumbnails');

    lazyBackground($thumbnailSlider);

    $slides.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: $thumbnails,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 4000,
    }).on('lazyLoadError', lazyLoadError);

    $thumbnails.slick({
        slidesToScroll: 1,
        prevArrow: defaultPrevArrow,
        nextArrow: defaultNextArrow,
        asNavFor: $slides,
        focusOnSelect: true,
    }).on('lazyLoadError', lazyLoadError);
});



// WEBPACK FOOTER //
// ./src/js/components/ui-c-slider/index.js